export const handleTableSelection = <T extends { id?: string }>({
  currentSelection,
  value,
  type,
  currentPageItems,
  calculateTotal,
}: {
  currentSelection: T[]
  value: T[]
  type?: "multiple" | "all" | "checkbox" | "row" | undefined
  currentPageItems: T[]
  calculateTotal?: (items: T[]) => number
}): { items: T[]; total: number } => {
  const selectedCopy = [...currentSelection]

  const pageIds = new Set(
    currentPageItems
      .map((item) => item.id)
      .filter((id): id is string => Boolean(id))
  )

  const areAllPageItemsSelected = currentPageItems.every(
    (item) =>
      item.id && selectedCopy.some((selected) => selected.id === item.id)
  )

  const removePageItems = (copy: T[]): T[] =>
    copy.filter((selected) => !selected.id || !pageIds.has(selected.id))

  const addMissingPageItems = (copy: T[]): T[] => {
    const selectedIds = new Set(copy.map((s) => s.id))
    const itemsToAdd = currentPageItems.filter(
      (item) => item.id && !selectedIds.has(item.id)
    )
    return [...copy, ...itemsToAdd]
  }

  const replacePageSelection = (copy: T[]): T[] => {
    const withoutPage = removePageItems(copy)
    const withoutPageIds = new Set(withoutPage.map((s) => s.id))
    const toAdd = value.filter(
      (item) => item.id && !withoutPageIds.has(item.id)
    )
    return [...withoutPage, ...toAdd]
  }

  const newSelection =
    type === "all"
      ? areAllPageItemsSelected
        ? removePageItems(selectedCopy)
        : addMissingPageItems(selectedCopy)
      : replacePageSelection(selectedCopy)

  return {
    items: newSelection,
    total: calculateTotal ? calculateTotal(newSelection) : 0,
  }
}
